/*
 *
 * CostsCustomDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jul-2025
*/

import CostsCustomDownloadModal from './CostsCustomDownloadModalContainer'

export default CostsCustomDownloadModal
